import caution from 'assets/images/caution.png';
import {AxiosError} from "axios";
import {useUserContext} from "../../types/contexts/UserContext";
import {useMemo} from "react";
import {Alert} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

function ErrorFallback({error}: { error: any }) {
    let errorTitle = 'Something went wrong'
    const user = useUserContext();

    if (error instanceof AxiosError) {
        if (error.response?.data.message) {
            errorTitle = error.response?.data.message;
        }

    }


    const brokerUI = useMemo(() => {
        return <div role="alert" className={`fixed top-0 left-0 w-screen text-sm h-screen`}>
            <div className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                <div className="text-center">
                    <img alt="Warning" src={caution} className="w-[64px] h-[64px] mb-6 inline-block"/>
                </div>
                <p className="text-lg text-black text-center dark:text-white">{errorTitle}</p>
            </div>
        </div>;
    }, [errorTitle]);

    const userUI = useMemo(() => {
        return <Alert
            icon={<FontAwesomeIcon icon={solid("circle-exclamation")}/>}
            className="rounded-none border-l-4 bg-red-500 font-medium text-white max-w-xs fixed right-2 top-2 "
        >
            {errorTitle}
        </Alert>
    }, [errorTitle]);
    return (
        user ? userUI : brokerUI
    )

}

export default ErrorFallback;
